module.exports = __webpack_public_path__ + "assets/f82362cb4f85ac8ea7852c1145bf58e0.png";